import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-soleil-nyakiriza-bi',
  templateUrl: './soleil-nyakiriza-bi.component.html',
  styleUrls: ['./soleil-nyakiriza-bi.component.scss']
})
export class SoleilNyakirizaBiComponent {

  constructor() { }

}
